



























import NavPrimary from "@/components/NavPrimary.vue";
import url from "@/mixins/analytics/url";
import { Component, Mixins } from "vue-property-decorator";

@Component({ components: { NavPrimary } })
export default class AppNav extends Mixins(url) {
  isOpen = false;

  get ARIAState() {
    return this.isOpen ? "true" : "false";
  }
}
